module.exports = __webpack_public_path__ + "static/media/moldura_yeso.5b69f22b.jpg";